<template>
  <div>
    <div class="font-light text-xs">
      <!-- {{ $i18nPresenter.t("Collaboration is currently limited to") }}
        {{ teamName }} {{ $i18nPresenter.t("members only.") }} -->
      Only members of <strong class="font-bold">{{ teamName }}</strong> can edit this presentation.
    </div>
    <div class="list-member">
      <div
        v-for="member in teamMembers"
        :key="member.id"
        class="flex flex-row items-center mb-4"
      >
        <div>
          <aha-avatar
            :name="`${member.firstName} ${member.lastName}`"
            :image="member.avatar"
            :id="member.id"
            :width="36"
            :height="36"
            class="mr-2 text-lg"
          />
        </div>
        <div class="flex flex-col max-w-60 list-member-info">
          <div class="font-bold mb-1">
            {{ getMemberName(member) }}
            <PresentingRightPlanLabel
              v-if="isEnableEditorPresentingRight && member.accountRole !== 'viewer'"
              class="inline-block ml-1"
              :owner="presentation.User"
              :editor="member"
              :editorName="getMemberName(member)"
              style="top: 5px;"
            />
          </div>
          <div class="inline-flex text-xs text-base-80">
            {{ member.email }}
          </div>
        </div>
        <div class="text-xs ml-auto">
          {{ getMemberPermissionRole(member) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserApi from '@/api/user'
import Util from '@/util'
import constants from '@/constant'
import PresentingRightPlanLabel from '@/components-v2/presentation-editor/collaboration/PresentingRightPlanLabel.vue'

export default {
  name: 'ShareToTeamForEditMain',
  components: {
    PresentingRightPlanLabel,
  },
  props: {
    teamName: {
      type: String,
      default: 'your current team',
    },
    presentation: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      teamMembers: {},
      totalMembers: '',
    }
  },
  computed: {
    ...mapGetters(['isEnableEditorPresentingRight']),
  },
  mounted() {
    this.getMyTeam()
  },
  methods: {
    hide() {
      this.$emit('hide')
    },
    async getMyTeam() {
      if (!this.$store.state.currentUser.id) {
        return
      }

      try {
        const res = await UserApi.getTeamMembers({
          userId: this.$store.state.currentUser.id,
          size: 30,
        })
        const { totalUsers, users } = res
        this.teamMembers = users
        this.totalMembers = totalUsers
        this.syncCurrentUser()
      } catch (error) {
        Util.mixpanelTracking('My Team', 'Get user team', 'Get user plan failed')
        throw error
      }
    },
    getMemberPermissionRole(member) {
      const { accountRole } = member
      if (this.presentation.User.id === member.id) return 'Owner'
      if (accountRole === constants.workspace.OWNER) return 'Editor'
      if (accountRole === constants.workspace.ADMIN) return 'Editor'
      if (accountRole === constants.workspace.EDITOR) return 'Editor'
      if (accountRole === constants.workspace.VIEWER) return 'Viewer'
      return 'Viewer'
    },
    getMemberName(member) {
      return `${member.firstName} ${member.lastName}`.replace(/\s+/g, ' ').trim()
    },
    syncCurrentUser() {
      const lastestCurrentUser = this.teamMembers.find(
        (item) => item.id === this.$store.state.currentUser.id,
      )
      if (lastestCurrentUser.accountRole !== this.$store.state.currentUser.accountRole) {
        this.$store.state.currentUser.accountRole = lastestCurrentUser.accountRole
      }
    },
  },
}
</script>

<style scoped lang="scss">
.list-member {
  @apply mt-4 mb-6;
  padding-right: 2rem;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 14rem;
  .list-member-info {
    div {
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      -webkit-box-orient: vertical;
    }
  }
}
</style>
